module.exports = __webpack_public_path__ + "static/media/contact_us_student_original.23045864.jpeg";